import endpoint from '../util/endpoint';
import conectionDebug from './conectionDebug';
import Connection from './connection';

const bus = new Connection({
    name: 'storeManager',
    url: ({ storeGuid }) => storeGuid && endpoint('storeManager.signalR', { storeGuid }).url,
    dependencies: { storeGuid: 'url.params.storeGuid' },
});
bus.options.debug = conectionDebug;
export default bus;
